module.exports = __webpack_public_path__ + "static/Burst_3-fe36275edc215d6ac8f724c31d6bea00.jpg";